export default function Shell({ children, wide = false }) {
  return (
    <div className="min-h-screen w-full bg-[#EBEBEB] flex items-center justify-center p-4 sm:p-6">
      <div
        data-testid="appt-confirm-card"
        className={`w-full ${wide ? "max-w-lg" : "max-w-md"} bg-white rounded-[28px] border border-black/[0.06] p-7 sm:p-9`}
      >
        {children}
      </div>
    </div>
  );
}
